import React from 'react';
import { LANDPAGE_HERO } from '../../Landpage/landpage.constants';
import HeroBackgroundImage from '../../Landpage/components/onboardingHero/HeroBackgroundImage';
import HeroHeader from '../../Landpage/components/onboardingHero/HeroHeader';
import HeroTitle from '../../Landpage/components/onboardingHero/HeroTitle';
import {
  CHECKOUT_WELCOME_NEXT_STEPS_MESSAGE,
  CHECKOUT_WELCOME_SUPPORT_HINT_MESSAGE,
  CHECKOUT_WELCOME_THANK_YOU_MESSAGE,
} from '../checkout.constants';
import heroStyles from '../../Landpage/components/onboardingHero/onboardingHero.module.css';
import styles from './CheckoutWelcomeView.module.css';

const CheckoutWelcomeView: React.FC = () => (
  <section className={`${heroStyles.heroSection} ${styles['welcome-section']}`}>
    <div className={`${heroStyles.heroVisual} ${styles['welcome-visual']}`}>
      <div className={`${heroStyles.heroBackground} ${styles['welcome-background']}`}>
        <HeroBackgroundImage
          src={LANDPAGE_HERO.backgroundImageSrc}
          alt={LANDPAGE_HERO.backgroundImageAlt}
          objectPosition="center center"
        />
      </div>
      <HeroHeader
        supportLabel={LANDPAGE_HERO.supportButtonLabel}
        supportHref={LANDPAGE_HERO.supportWhatsAppUrl}
      />
      <div className={heroStyles.headerDivider} aria-hidden="true" />
      <div className={`${heroStyles.content} ${styles['welcome-content']}`}>
        <HeroTitle
          lineOne={LANDPAGE_HERO.titleLineOne}
          lineTwo={LANDPAGE_HERO.titleLineTwo}
        />
        <p className={styles['welcome-message']}>
          {CHECKOUT_WELCOME_THANK_YOU_MESSAGE}
        </p>
        <p className={styles['welcome-next-steps']}>
          {CHECKOUT_WELCOME_NEXT_STEPS_MESSAGE}
        </p>
        <p className={styles['welcome-next-steps']}>
          {CHECKOUT_WELCOME_SUPPORT_HINT_MESSAGE}
        </p>
      </div>
    </div>
  </section>
);

export default CheckoutWelcomeView;
